import useCoreModelsFind from 'hooks/useCoreModelsFind'

export default (scheduleTimelogId, opts) => useCoreModelsFind('scheduleTimelog', scheduleTimelogId, opts)
